import React from 'react';

import SuperAdminAnalytics from './SuperAdminAnalytics-new';

function OrganizationAnalytics(): React.ReactElement
{
  return <SuperAdminAnalytics scope="organization" />;
}

export default OrganizationAnalytics;

